import React from "react";
import MainPage from "../_layout/main.page";
export const Profile = () => {
  return (
    <>
      <MainPage>
        <div className="page_head-top  ">
          <div className="page-head-title ">
            <h5>Profile</h5>
          </div>
          <div className="page-head-buttons "></div>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-4">
                <div className="card">
                  <div className="card-body"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainPage>
    </>
  );
};
